<template>
  <div class="scenario_result">
    <div class="s-result_top educationmod">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首頁</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'needs_analysis'}">人生藍圖計算機</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name: 'educationFund'}">子女教育金試算</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">試算結果</li>
          </ol>
        </nav>
        <div class="s-result_top--img">
          <img src="@/assets/images/needs/banner-education/02/children-focus.svg" alt="">
        </div>
        <div class="s-result_top--text">
          <h4>根據你的分析結果 <br>{{ kidAmount }} 位子女的教育金共</h4>
          <p>{{ KEF_total | currency }}<span> 元</span></p>
        </div>

        <div class="s-result_top--progress">
          <div class="progress_line">
            <ul class="line_percent">
              <li class="kindergarten" :style="{width: KEF_kindergartenPercent + '%'}">{{
                  KEF_kindergartenPercent
                }}%
              </li>
              <li
                  v-if="KEF_elementaryPercent > 0"
                  class="elementary"
                  :style="{width: KEF_elementaryPercent + '%'}">
                {{ KEF_elementaryPercent }}%
              </li>
              <li
                  v-if="KEF_juniorPercent > 0"
                  class="secondary"
                  :style="{width: KEF_juniorPercent + '%'}">
                {{ KEF_juniorPercent }}%
              </li>
              <li
                  v-if="KEF_highPercent > 0"
                  class="highschool"
                  :style="{width: KEF_highPercent + '%'}">
                {{ KEF_highPercent }}%
              </li>
              <li
                  v-if="KEF_universityPercent > 0"
                  class="university"
                  :style="{width: KEF_universityPercent + '%'}">
                {{ KEF_universityPercent }}%
              </li>
              <li
                  v-if="KEF_graduatePercent > 0"
                  class="graduate"
                  :style="{width: KEF_graduatePercent + '%'}">
                {{ KEF_graduatePercent }}%
              </li>
              <div class="statistics_tip">
                <ul>
                  <li>
                    <span class="square kindergarten"></span>
                    <div class="name">幼稚園</div>
                    <div class="cost">{{ KEF_kindergarten | currency }} 元</div>
                  </li>
                  <li>
                    <span class="square elementary"></span>
                    <div class="name">國小</div>
                    <div class="cost">{{ KEF_elementary | currency }} 元</div>
                  </li>
                  <li>
                    <span class="square secondary"></span>
                    <div class="name">國中</div>
                    <div class="cost">{{ KEF_junior | currency }} 元</div>
                  </li>
                  <li>
                    <span class="square highschool"></span>
                    <div class="name">高中</div>
                    <div class="cost">{{ KEF_high | currency }} 元</div>
                  </li>
                  <li>
                    <span class="square university"></span>
                    <div class="name">大學</div>
                    <div class="cost">{{ KEF_university | currency }} 元</div>
                  </li>
                  <li>
                    <span class="square graduate"></span>
                    <div class="name">研究所</div>
                    <div class="cost">{{ KEF_graduate | currency }} 元</div>
                  </li>
                </ul>
              </div>
            </ul>
          </div>

          <div class="progress_legend">
            <ul class="legend_each">
              <li>
                <span class="square kindergarten"></span> 幼稚園
              </li>
              <li>
                <span class="square elementary"></span> 國小
              </li>
              <li>
                <span class="square secondary"></span> 國中
              </li>
              <li>
                <span class="square highschool"></span> 高中
              </li>
              <li>
                <span class="square university"></span> 大學
              </li>
              <li>
                <span class="square graduate"></span> 研究所
              </li>
            </ul>
          </div>
        </div>

        <div class="s-result_top--btn row">
          <div class="col-xs-6 col-md-2 col-md-offset-4 form-group">
            <div class="share_btn share_btn_orange">
              <router-link :to="{name: `${moduleName}_form`}">重新試算</router-link>
            </div>
          </div>
          <div class="col-xs-6 col-md-2 form-group">
            <div class="share_btn share_btn_orangeDefault">
              <a class="click_needs_analysis_consult_top"
                @click="toForm('專人諮詢', '')">我想了解</a>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="edu_s-result_content">
      <div class="container">
        <h3 class="edu_title_tip">養兒第一步：準備階段性的教育金 <i class="fas fa-question-circle">
          <span class="tip_content">別緊張！我們一步一步來，建議你優先準備下表★所標示的階段花費。此建議階段多半是接下來會面臨的高額花費。</span></i>
        </h3>
        <div class="edu_s-result_content--chart">
          <div class="edu_chart_wrap_list">
            <div class="donuts_chart">
              <!-- <canvas id="ScenarioresultChart"></canvas> -->
              <div class="edu_donuts_chart_rate">
                <span class="percent">{{ achievementRate }}%</span>
                <p class="rate_tip">教育金達成率 <i class="fas fa-question-circle">
                  <span class="tip_content">即為「建議準備的階段性教育金」達成率。</span>
                </i></p>
              </div>
            </div>

            <div class="chart_list">
              <!-- <div class="formula_summary_line">
                <div class="summary_border">
                  <div class="title_coin">
                  <img src="@/assets/images/needs/banner-retire/coin.svg" alt="">
                  </div>
                  <div class="formula_title">
                  <b>子女教育金試算結果</b>
                  </div>
                </div>
              </div> -->
              <div class="table_step">
                <div class="step_wrap">
                  <div class="step_title">
                    <p class="rate_tip">建議先準備的教育階段</p>
                  </div>
                  <div class="step_content">
                    <div class="step_head">
                      <ul>
                        <li>
                        </li>
                        <li v-for="item in babyHead">
                          <div class="baby_head"></div>
                          <span>{{ item }}</span>
                        </li>
                        <li v-for="item in (5 - babyHead.length)">
                          <div class="count_head"></div>
                        </li>
                      </ul>
                    </div>

                    <div class="step_star">
                      <ul v-for="item in stepStar">
                        <li>{{ item.title }}</li>
                        <li :class="item.kid_0"></li>
                        <li :class="item.kid_1"></li>
                        <li :class="item.kid_2"></li>
                        <li :class="item.kid_3"></li>
                        <li :class="item.kid_4"></li>
                      </ul>
                    </div>
                  </div>
                  <p class="slide_hint"><i class="fas fa-chevron-left"></i><i class="fas fa-chevron-left"></i>
                    可往右滑動看更多資訊 <i class="fas fa-chevron-right"></i><i class="fas fa-chevron-right"></i></p>
                </div>
              </div>

              <div class="step_table_list">
                <ul>
                  <li>
                    <div class="list_text">建議規劃的資金共需</div>
                    <p><span>{{ needPreparedFund | currency }}</span> 元</p>
                  </li>
                  <li>
                    <div class="list_text">目前可動用資金</div>
                    <p><span>{{ alreadyPrepare | currency }}</span> 元</p>
                  </li>
                  <li>
                    <div class="list_text">距離存到教育金還差</div>
                    <p><span>{{ lackPrepareFund | currency }}</span> 元</p>
                  </li>
                  <li>
                    <div class="list_text">達成教育金建議再存</div>
                    <p><span class="more_money">{{ suggestSavePerMoney | currency }}</span> 元／月</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="edu_extra_btn">
            <div class="edu_extra_btn_gray">
              <a href="javascript:;" data-popup="BreakUp1" class="click_needs_analysis_seeDetail">展開各階段教育金行情價 <i class="fas fa-chevron-right"></i></a>
            </div>
            <div class="CommonPopup sup_switch--modal" id="Popup__formAdd1">
              <div class="Popup__overlay"></div>
              <div class="Popup__box">
                <div class="Popup__content">
                  <div class="Popup__title">
                    <h3>各階段教育金行情價</h3>
                  </div>
                  <div class="Popup__paragraph">
                    <div class="extra_table">
                      <table class="table_wrap">
                        <tr>
                          <th class="side_stick" colspan="2">項目</th>
                          <td class="kindergarten">0~3歲<br>學齡前</td>
                          <td class="kindergarten">4~6歲<br>幼稚園</td>
                          <td class="elementary">7~12歲<br>國小</td>
                          <td class="secondary">13~15歲<br>國中</td>
                          <td class="highschool">16~18歲<br>高中</td>
                          <td class="university">19~22歲<br>大學</td>
                          <td class="graduate">23~25歲<br>研究所</td>
                        </tr>
                        <tr>
                          <th class="three_col side_stick" rowspan="2">教育學雜費</th>
                          <th class="two_col side_stick">公立</th>
                          <td>-</td>
                          <td>150,000</td>
                          <td>24,000</td>
                          <td>18,000</td>
                          <td>18,000</td>
                          <td>25,000</td>
                          <td>130,000</td>
                        </tr>
                        <tr>
                          <th class="two_col side_stick">私立</th>
                          <td>-</td>
                          <td>702,000</td>
                          <td>600,000</td>
                          <td>300,000</td>
                          <td>300,000</td>
                          <td>520,000</td>
                          <td>280,000</td>
                        </tr>
                        <tr>
                          <th class="side_stick" colspan="2">輔助教育費<br><span>安親班、補習費等</span></th>
                          <td>-</td>
                          <td>-</td>
                          <td>360,000</td>
                          <td>216,000</td>
                          <td>216,000</td>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                        <tr>
                          <th class="side_stick" colspan="2">生活費<br><span>食、衣、行等</span></th>
                          <td>792,000</td>
                          <td>72,000</td>
                          <td>184,000</td>
                          <td>92,000</td>
                          <td>210,000</td>
                          <td>288,000</td>
                          <td>144,000</td>
                        </tr>
                        <tr>
                          <th class="side_stick" colspan="2">零用錢</th>
                          <td>-</td>
                          <td>-</td>
                          <td>36,000</td>
                          <td>108,000</td>
                          <td>180,000</td>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                        <tr>
                          <th class="three_col side_stick" rowspan="2">合計</th>
                          <th class="two_col side_stick">公立</th>
                          <td>792,000</td>
                          <td>222,000</td>
                          <td>604,000</td>
                          <td>434,000</td>
                          <td>624,000</td>
                          <td>826,000</td>
                          <td>418,000</td>
                        </tr>
                        <tr>
                          <th class="two_col side_stick">私立</th>
                          <td>792,000</td>
                          <td>774,000</td>
                          <td>1,180,000</td>
                          <td>716,800</td>
                          <td>906,000</td>
                          <td>1,096,000</td>
                          <td>568,000</td>
                        </tr>
                      </table>
                    </div>
                    <p class="slide_hint"><i class="fas fa-chevron-left"></i><i class="fas fa-chevron-left"></i>
                      可往右滑動看更多資訊 <i class="fas fa-chevron-right"></i><i class="fas fa-chevron-right"></i></p>
                  </div>

                  <div class="Popup__close" data-popup="BreakUp-close">
                    <i class="fas fa-times"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
        v-if="suggestSavePerMoney > 1500"
        class="edu_s-result_sup">
      <div class="container">
        <h3>養兒第二步：達成階段性的教育金</h3>
        <p>準備子女教育金，現在就開始著手吧！<br>快看看我們為你精心挑選的方案。</p>
        <div class="edu_sup_part">
          <div class="owl-carousel owl-theme">
            <div class="edu_sup_block_wrap item">
              <div class="edu_sup_block">
                <h4>方案一</h4>
                <div class="edu_sup_block--w edu_savemod">
                  <!-- <div class="edu_currency_sticker">
                    <div class="edu_currency_tip USD">
                      美元保單
                    </div>
                  </div> -->
                  <div class="edu_currency_sticker">
                    <div class="edu_currency_tip NTD">
                      台幣保單
                    </div>
                  </div>
                  <div class="edu_sup_rate">
                    <p>報酬率</p>
                    <span class="edu_rate_gap">{{ t_returnRate }}%</span>
                  </div>

                  <div class="edu_sup_count">
                    <div class="edu_count_each">
                      <p class="edu_count_each--item">從現在連續 {{ t_saveInRowYear }} 年存</p>
                      <p class="edu_count_each--num">{{ t_saveInRowAmount | currency }}<span> 元</span>
                      </p>
                    </div>
                    <div class="edu_count_each">
                      <p class="edu_count_each--item">第 {{ yearGetBack }} 年可領回</p>
                      <p class="edu_count_each--num">{{ t_getAmount | currency }}<span> 元</span>
                      </p>
                    </div>
                    <div class="edu_count_each">
                      <p class="edu_count_each--item">達成率提升至</p>
                      <div class="edu_count_each--progress">
                        <div class="edu_progress_mix">
                          <div class="edu_progress_bar" role="progressbar"
                               :style="{width: (achievementRate + t_raisedAchievementRate > 100 ? 100 : achievementRate) + '%' }"></div>
                          <div class="edu_progress_bar edu_bar_fill" role="progressbar"
                               :style="{width: t_raisedAchievementRate + '%' }"></div>
                        </div>
                        <label class="progress_num">{{ achievementRate + t_raisedAchievementRate }}%</label>
                      </div>

                    </div>

                    <div class="edu_count_each reasonmod">
                      <p class="edu_count_each--item">方案說明</p>
                      <p class="edu_count_each--num"><i class="fas fa-chevron-down"></i></p>
                      <p class="edu_count_each--text">
                        子女教育金的首要重點是資金的穩健性，能避免小孩因為投資風險，而造成受教育的費用有所限制，所以已儲蓄險進行搭配，
                        儲蓄險能有效的強迫儲蓄，並且能將未來利率鎖定於現在，不受利率下跌影響。 </p>
                    </div>
                  </div>
                  <!--                  <div class="save_count">-->
                  <!--                    <div class="save_each">-->
                  <!--                      <p>從現在連續 <span>5</span> 年存 </p>-->
                  <!--                      <div class="number"><span>15,865</span> 元／年</div>-->
                  <!--                    </div>-->
                  <!--                    <div class="save_each">-->
                  <!--                      <p>第 <span>10</span> 年可領回</p>-->
                  <!--                      <div class="number"><span>63,548</span> 元／年</div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div
                      class="col-md-8 col-md-offset-2 share_btn share_btn_orangeDefault">
                    <a class="click_needs_analysis_consultPlan_1" @click="toForm('方案一', t_productName)">我想了解</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="edu_sup_block_wrap item">
              <div class="edu_sup_block">
                <h4>方案二</h4>
                <div class="edu_sup_block--w edu_savemod">
                  <div class="edu_currency_sticker">
                    <div class="edu_currency_tip USD">
                      美元保單
                    </div>
                  </div>
                  <div class="edu_sup_rate">
                    <p>報酬率</p>
                    <span class="edu_rate_gap">{{ u_returnRate }}%</span>
                  </div>

                  <div class="edu_sup_count">
                    <div class="edu_count_each">
                      <p class="edu_count_each--item">從現在連續 {{ u_saveInRowYear }} 年存</p>
                      <p class="edu_count_each--num">{{ u_saveInRowAmount | currency }}<span> 元</span>
                      </p>
                    </div>
                    <div class="edu_count_each">
                      <p class="edu_count_each--item">第 {{ yearGetBack }} 年可領回</p>
                      <p class="edu_count_each--num">{{ u_getAmount | USD_currency }}<span> 元</span>
                      </p>
                    </div>
                    <div class="edu_count_each">
                      <p class="edu_count_each--item">達成率提升至</p>
                      <div class="edu_count_each--progress">
                        <div class="edu_progress_mix">
                          <div class="edu_progress_bar" role="progressbar"
                               :style="{width: (achievementRate + u_raisedAchievementRate > 100 ? 100 : achievementRate) + '%' }"></div>
                          <div class="edu_progress_bar edu_bar_fill" role="progressbar"
                               :style="{width: u_raisedAchievementRate + '%' }"></div>
                        </div>
                        <label class="progress_num">{{ achievementRate + u_raisedAchievementRate }}%</label>
                      </div>

                    </div>

                    <div class="edu_count_each reasonmod">
                      <p class="edu_count_each--item">方案說明</p>
                      <p class="edu_count_each--num"><i class="fas fa-chevron-down"></i></p>
                      <p class="edu_count_each--text">
                        注意美元儲蓄險仍有匯率風險，留意最終解約時的匯率，才能避免虧損，當然也有賺錢的機會。子女教育金的首要重點在於資金的穩健性，避免子女因投資風險，而造成教育費用受到限制，利用儲蓄險能有效強迫儲蓄，並將未來利率鎖定於現在，不受利率下跌影響。
                      </p>
                    </div>
                  </div>
                  <div class="col-md-8 col-md-offset-2 share_btn share_btn_orangeDefault">
                    <a class="click_needs_analysis_consultPlan_2" @click="toForm('方案二', u_productName)">我想了解</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="edu_sup_block_wrap bigpresentmod item">
              <div class="edu_sup_block">
                <h4>方案三</h4>
                <div class="edu_sup_block--w edu_savemod">
                  <div class="center_layout">
                    <div class="center_img">
                      <img src="@/assets/images/needs/banner-house/support.svg" alt="">
                    </div>
                    <p class="edu_count_each--text">利用上述的試算結果，搭配「專人的客觀解析」，必定能為你找出儲存子女教育金，最合適的方法。</p>
                    <div class="col-md-8 col-md-offset-2 share_btn share_btn_orangeDefault">
                      <a class="click_needs_analysis_consultPlan_3" @click="toForm('方案三', '')">我想了解</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div
        v-else
        class="edu_s-result_sup">
      <div class="container">
        <h3>養兒第二步：達成階段性的教育金</h3>
        <p>想盡早實現買房藍圖，現在就開始著手吧！<br>快看看我們為你精心挑選的方案。</p>
        <div class="edu_sup_part">
          <div class="owl-carousel owl-theme">
            <div class="edu_sup_block_wrap item">
              <div class="edu_sup_block">
                <h4>方案一</h4>
                <div class="edu_sup_block--w edu_savemod">
                  <div class="edu_currency_sticker">
                    <div class="edu_currency_tip RCD">
                      推薦保單
                    </div>
                  </div>

                  <div class="edu_sup_rate">
                    <p>此方案年保費</p>
                    <span class="edu_rate_gap">{{ premium_1 | currency }}</span>

                  </div>
                  <div class="edu_sup_count">
                    <div class="edu_count_each">
                      <p class="edu_count_each--item">意外失能</p>
                      <p class="edu_count_each--num">3,000,000<span> 元</span>
                      </p>
                    </div>
                    <div class="edu_count_each">
                      <p class="edu_count_each--item">意外實支實付</p>
                      <p class="edu_count_each--num">100,000<span> 元</span>
                      </p>
                    </div>
                    <div class="edu_count_each">
                      <p class="edu_count_each--item">醫療實支實付</p>
                      <p class="edu_count_each--num">250,000<span> 元</span>
                      </p>
                    </div>
                    <div class="edu_count_each reasonmod">
                      <p class="edu_count_each--item">方案說明</p>
                      <p class="edu_count_each--num"><i class="fas fa-chevron-down"></i>
                      <p>
                      <p class="edu_count_each--text">
                        為自己把醫療資源及早準備好，才不用擔心因疾病或意外，動用到好不容易存下的子女教育金！利用意外險及醫療險作為支柱，建立足夠的風險保障，便不用擔心自己有天成為家人的負擔，或生活發生重大變故了。
                      </p>
                    </div>
                  </div>

                  <div class="col-md-8 col-md-offset-2 share_btn share_btn_orangeDefault">
                    <a class="click_needs_analysis_consultPlan_1" @click="toForm('方案一 (意外加醫療險)', product_id_1)">我想了解</a>
                  </div>


                </div>
              </div>
            </div>
            <div class="edu_sup_block_wrap item">
              <div class="edu_sup_block">
                <h4>方案二</h4>
                <div class="edu_sup_block--w edu_savemod">
                  <div class="edu_currency_sticker">
                    <div class="edu_currency_tip RCD">
                      推薦保單
                    </div>
                  </div>

                  <div class="edu_sup_rate">
                    <p>此方案年保費</p>
                    <span class="edu_rate_gap">{{ premium_2 | currency }}</span>

                  </div>
                  <div class="edu_sup_count">
                    <div class="edu_count_each">
                      <p class="edu_count_each--item">意外失能</p>
                      <p class="edu_count_each--num">3,000,000<span> 元</span>
                      </p>
                    </div>
                    <div class="edu_count_each">
                      <p class="edu_count_each--item">意外實支實付</p>
                      <p class="edu_count_each--num">100,000<span> 元</span>
                      </p>
                    </div>
                    <div class="edu_count_each reasonmod">
                      <p class="edu_count_each--item">方案說明</p>
                      <p class="edu_count_each--num"><i class="fas fa-chevron-down"></i>
                      <p>
                      <p class="edu_count_each--text">當意外發生時，擔心自己成為家人的負擔？或是因為自己沒辦法給子女們最好的教育？利用意外險作為支柱，補足足夠的風險保障，就再也不用擔心生活發生變故了。 </p>
                    </div>
                  </div>
                  <div class="col-md-8 col-md-offset-2 share_btn share_btn_orangeDefault">
                    <a class="click_needs_analysis_consultPlan_2" @click="toForm('方案二 (意外險)', product_id_2)">我想了解</a>
                  </div>


                </div>
              </div>
            </div>
            <div class="edu_sup_block_wrap bigpresentmod item">
              <div class="edu_sup_block">
                <h4>方案三</h4>
                <div class="edu_sup_block--w edu_sup_block--h edu_savemod">

                  <div class="center_layout">
                    <div class="center_img">
                      <img src="@/assets/images/needs/banner-house/support.svg" alt="">
                    </div>
                    <p class="edu_count_each--text">
                      利用上述的試算結果，搭配專人的客觀解析，必定能為你找出實踐買房夢想，最合適的方法。
                    <div class="col-md-8 col-md-offset-2 share_btn share_btn_orangeDefault">
                      <a class="click_needs_analysis_consultPlan_3" @click="toForm('方案三', '')">我想了解</a>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get} from "vuex-pathify";

export default {
  name: "education_fund_result",
  data() {
    return {
      moduleName: '',
    }
  },
  methods: {
    async toForm(plan, productName) {
      let planObj = {
        name: plan,
        product: productName
      }
      let token = this.$route.params.token
      await store.dispatch(`${this.moduleName}/updateSBData`, {token, planObj})
    },
    async setData() {
      let token = this.$route.params.token
      await store.dispatch(`${this.moduleName}/getSBEducationFundData`, token)
    },
    openPopup(popupId) {
      if (popupId === '#Popup__formAdd1') {
        this.$refs.popup.openAddPopup(popupId)
        this.$refs.popup.setBarRange()
      }
    },
    setOwlCarousel() {
      $('.owl-carousel').owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        dots: true,
        responsive: {
          0: {
            items: 1,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
          },
          768: {
            items: 2,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
          },
          1200: {
            items: 3,
            loop: false,
            mouseDrag: false,
            touchDrag: false,
            dots: false,
          }
        }
      })
    },
    setChart() {
      var ctx = document.getElementById("ScenarioresultChart");
      new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: ['已達成', '勞保'],
          datasets: [{
            label: '# of Tomatoes',
            data: [this.achievementRate, 100 - this.achievementRate],
            backgroundColor: [
              '#F49202',
              '#565656'
            ],
            borderWidth: 1
          }]
        },
        options: {
          responsive: false,

          legend: {
            display: true
          },
          tooltips: {
            enabled: true,
            titleFontSize: 16,
            bodyFontSize: 16,
          }
        }
      });
    },
    setChartOnTime() {
      if (this.achievementRate) this.setChart()
      else setTimeout(() => this.setChartOnTime(), 200)
    },
    setPopUp() {
      $(function () {
        $('[data-popup="BreakUp1"]').on('click', function () {
          openAddPopup()
        })
        $('[data-popup="BreakUp-close"]').on('click', function () {
          closeAddPopup()
        })
        $('[data-popup="grade_close_icon"]').on('click', function () {
          closeGradePopup()
        })

        function openAddPopup() {
          $('#Popup__formAdd1').fadeIn(500)
        }

        function closeAddPopup() {
          $('#Popup__formAdd1').fadeOut(500)
        }
      });
    },
    textToggle() {
      $('.reasonmod').on('click', function () {
        $(this).toggleClass('text-open')
      });
    },
  },
  created() {
    this.moduleName = 'educationFund'
    store.set('moduleName', this.moduleName)
    this.setData()
  },
  mounted() {
    this.setOwlCarousel()
    this.setPopUp()
    this.textToggle()
    // this.setChartOnTime()
  },
  computed: {
    ...get('educationFund', {
      hasData: 'result@hasData',
      kidAmount: 'result@kidAmount',
      KEF_kindergarten: 'result@kidsEducationFund.kindergarten',
      KEF_elementary: 'result@kidsEducationFund.elementary',
      KEF_junior: 'result@kidsEducationFund.junior',
      KEF_high: 'result@kidsEducationFund.high',
      KEF_university: 'result@kidsEducationFund.university',
      KEF_graduate: 'result@kidsEducationFund.graduate',
      KEF_kindergartenPercent: 'result@kidsEducationFund.kindergartenPercent',
      KEF_elementaryPercent: 'result@kidsEducationFund.elementaryPercent',
      KEF_juniorPercent: 'result@kidsEducationFund.juniorPercent',
      KEF_highPercent: 'result@kidsEducationFund.highPercent',
      KEF_universityPercent: 'result@kidsEducationFund.universityPercent',
      KEF_graduatePercent: 'result@kidsEducationFund.graduatePercent',
      KEF_total: 'result@kidsEducationFund.total',
      achievementRate: 'result@achievementRate',
      kids: 'result@apiData.kids',
      needPreparedFund: 'result@needPreparedFund',
      alreadyPrepare: 'result@alreadyPrepare',
      lackPrepareFund: 'result@lackPrepareFund',
      suggestSavePerMoney: 'result@suggestSavePerMoney',
      t_raisedAchievementRate: 'result@t_raisedAchievementRate',
      t_returnRate: 'result@t_returnRate',
      t_saveInRowAmount: 'result@t_saveInRowAmount',
      t_saveInRowYear: 'result@t_saveInRowYear',
      t_productName: 'result@tripleIData.t_productName',
      t_getAmount: 'result@t_getAmount',
      u_productName: 'result@tripleIData.u_productName',
      u_getAmount: 'result@u_getAmount',
      u_raisedAchievementRate: 'result@u_raisedAchievementRate',
      u_returnRate: 'result@u_returnRate',
      u_saveInRowAmount: 'result@u_saveInRowAmount',
      u_saveInRowYear: 'result@u_saveInRowYear',
      yearGetBack: 'result@yearGetBack',
      premium_1: 'result@premium_1',
      premium_2: 'result@premium_2',
    }),
    babyHead() {
      let babyArr = [
        '大寶',
        '二寶',
        '三寶',
        '四寶',
        '小寶貝',
      ]
      return babyArr.slice(0, this.kidAmount)
    },
    stepStar() {
      let step = []
      let stages = ['國小', '國中', '高中', '大學', '研究所']
      stages.forEach(stage => {
        step.push({
          kid_0: '',
          kid_1: '',
          kid_2: '',
          kid_3: '',
          kid_4: '',
          title: stage,
        })
      })
      if (this.kids) {
        this.kids.forEach((kid, index) => {
          switch (kid.edu_stage_advice) {
            case "elementary":
              step[0][`kid_${index}`] = 'priority'
              break
            case "junior":
              step[1][`kid_${index}`] = 'priority'
              break
            case "high":
              step[2][`kid_${index}`] = 'priority'
              break
            case "university":
              step[3][`kid_${index}`] = 'priority'
              break
            case "graduate":
              step[4][`kid_${index}`] = 'priority'
              break
          }
        })
      }
      return step
    },
    product_id_1() {
      return store.get(`${this.moduleName}/formData.currentAge`) < 45 ?
          '70bdb9ef4a7a7cd1b1c009ae1667b146' :
          '7feadebcb61c2dc39a74e38df307d830'
    },
    product_id_2() {
      return '7116ec4f16016a88d94bb8f1934f8f82'
    }
  },
  filters: {
    currency(value) {
      let num = (value || 0).toString(), result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      if (!result.indexOf('-,')) result = result.replace('-,', '-')
      return result;
    },
    USD_currency(value) {
      let num = (value * 28 || 0).toString(), result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }

      if (num) result = num + result;

      if (!result.indexOf('-,')) result = result.replace('-,', '-')

      return result;
    },
  }
}
</script>

<style scoped>

</style>